<template>
  <a-image
    v-bind="attrs"
    class="myImage"
    :src="realSrc"
    ref="imageRef"
    :preview="previewDisabled ? false : isVisible"
    :fallback="fallBack"
    decoding="async"
    loading="lazy"
    @error="handleError"
    @click="emit('imageClick', realSrc)"
  />
</template>

<script>
  export default {
    name: 'MyImage',
    inheritAttrs: false,
  };
</script>

<script setup>
  import { computed, ref, watch, useAttrs, defineProps, defineEmits } from 'vue';
  import fallBackImg from '@/assets/map/error.png';

  const props = defineProps({
    modelValue: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    placeHolder: {
      type: String,
      default: ''
    },
    fallBack: {
      type: String,
      default: fallBackImg
    },
    previewDisabled: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: '--'
    },
    srcFormatter: {
      type: Function,
      default: null
    }
  });

  const emit = defineEmits(['imageClick']);
  const attrs = useAttrs();
  const imageSrc = computed(() => {
    const src = props.src || props.modelValue || '';
    return src && props.srcFormatter ? props.srcFormatter(src) : src;
  });
  const isVisible = ref(false);
  const realSrc = ref('');
  const imageRef = ref();

  const handleError = () => {
    realSrc.value = props.fallBack;
    isVisible.value = !!props.fallBack;
  };

  watch(
    [imageSrc, () => props.fallBack],
    ([newSrc, fallback]) => {
      realSrc.value = newSrc || fallback || '';
      isVisible.value = !!realSrc.value;
    },
    { immediate: true }
  );
</script>

<style scoped lang="less">
  .myImage-empty {
    color: var(--custom-text-color-secondary, #86909c);
  }
</style>
